import { z, ZodType } from 'zod';

// TODO: sync all wallet response with back

export type EditWalletResponse = {
	id: number;
	balance: number;
	currency: string;
	numberOfBets: number;
	turnover: number;
	cashdeskProfit: number;
};

export const editWalletResponseSchema: ZodType<EditWalletResponse> = z.object({
	id: z.number(),
	balance: z.number(),
	currency: z.string(),
	numberOfBets: z.number(),
	turnover: z.number(),
	cashdeskProfit: z.number(),
});
